import API from "@/common/API";
import { parsedUser } from "@/common/GetCurrentUser";
import Settings from "@/common/Settings";
import { Routes } from "@/routes";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom"

const Search = (props: any) => {
    const [isLoading, setIsLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("");
    const [statusList, setStatusList] = useState<any[]>([]);
    const history = useHistory();
    const location = useLocation();
    const [records, setRecords] = useState<any[]>([]);

    const [stage, setStage] = useState("");
    const [stageList, setStageList] = useState<any[]>([]);

    const [assignedTo, setAssignedTo] = useState("");
    const [assignedToList, setAssignedToList] = useState<any[]>([]);

    const user = parsedUser();
    const { t } = useTranslation("global");
    const [isInitialized, setIsInitialized] = useState(false);

    // Function to get query parameters
    const getQueryParams = () => {
        const searchParams = new URLSearchParams(location.search);
        return {
            status: searchParams.get('status') || '',
            stage: searchParams.get('stage') || '',
            assignedTo: searchParams.get('assignedTo') || '',
            search: searchParams.get('search') || ''
        };
    };

    // Initialize state from query parameters
    useEffect(() => {
        const queryParams = getQueryParams();
        setStatus(queryParams.status);
        setStage(queryParams.stage);
        setAssignedTo(queryParams.assignedTo);
        setSearch(queryParams.search);
        setIsInitialized(true);
    }, [location.search]);


    // Function to update URL with current filter states
    const updateURL = useCallback(() => {
        const params = new URLSearchParams();
        if (search) params.set('search', search);
        if (status) params.set('status', status);
        if (stage) params.set('stage', stage);
        if (assignedTo) params.set('assignedTo', assignedTo);

        const newSearch = params.toString();
        const newPath = newSearch ? `${location.pathname}?${newSearch}` : location.pathname;

        // Only update if the URL actually changed
        if (location.pathname + location.search !== newPath) {
            history.replace(newPath);
        }
    }, [search, status, stage, assignedTo, location.pathname, location.search, history]);


    // Update URL when filters change (but not during initial load)
    useEffect(() => {
        if (isInitialized) {
            updateURL();
        }
    }, [search, status, stage, assignedTo, isInitialized]);


    const bindDataStatus = async () => {
        try {
            setIsLoading(true);
            const request = await API.getAction("placeStatus/list?organizationId=" + user?.OrganizationId);
            if (request.data.status === "ok") {
                setStatusList(request.data.response);
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("Error loading:", e);

        } finally {
            setIsLoading(false);
        }
    }

    const bindDataStage = async () => {
        try {
            setIsLoading(true);
            console.log(user);
            const request = await API.getAction("stage/list?organizationId=" + user?.OrganizationId);
            if (request.data.status === "ok") {
                setStageList(request.data.response);
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("Error loading :", e);

        } finally {
            setIsLoading(false);
        }
    }

    const bindDataUsers = async () => {
        try {
            setIsLoading(true);
            console.log(user);
            const request = await API.getAction("users/list?organizationId=" + user?.OrganizationId);
            if (request.data.status === "ok") {
                setAssignedToList(request.data.response);
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("Error loading :", e);

        } finally {
            setIsLoading(false);
        }
    }

    const bindData = async () => {
        try {
            setIsLoading(true);
            let query = `organizationId=${user?.OrganizationId}`;
            if (search) query += `&name=${search}`;
            if (status) query += `&placeStatusId=${status}`;
            if (stage) query += `&StageId=${stage}`;
            if (assignedTo) query += `&assignedTo=${assignedTo}`;

            const request = await API.getAction(`place/list?${query}`);
            if (request.data.status === "ok") {
                setRecords(request.data.response);
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("Error loading:", e);
            setRecords([]);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (search.length > 0 && search.length < 3) return;
        if (search.length === 0 && status === "" && stage === "" && assignedTo === "") {
            setRecords([]);
            return;
        }
        bindData();
    }, [search, status, stage, assignedTo]);

    useEffect(() => {
        bindDataStatus();
        bindDataStage();
        bindDataUsers();
    }, []);

    return (<Modal
        show={true}
        size="lg"
        onHide={props.toggle}
        className="chatContainer modalRight"
    >
        <Modal.Header closeButton>
            <Row>
                <Col>
                    <input
                        type="text"
                        className="form-control"
                        placeholder={t("Search")}
                        aria-label="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </Col>
                <Col>
                    <select
                        className="form-control" value={assignedTo} onChange={e => setAssignedTo(e.target.value)}>
                        <option value="">{t("Assigned To")}</option>
                        {assignedToList.map((item, index) => (
                            <option key={index} value={item?.id}>{item?.firstName} {item?.lastName}</option>
                        ))}
                    </select>
                </Col>
                <Col>
                    <select
                        className="form-control" value={stage} onChange={e => setStage(e.target.value)}>
                        <option value="">{t("Stage")}</option>
                        {stageList.map((stage, index) => (
                            <option key={index} value={stage.id}>{stage.name}</option>
                        ))}
                    </select>
                </Col>
                <Col>
                    <select
                        className="form-control" value={status} onChange={e => setStatus(e.target.value)}>
                        <option value="">{t("Status")}</option>
                        {statusList.map((status, index) => (
                            <option key={index} value={status.id}>{status.name}</option>
                        ))}
                    </select>
                </Col>
                <Col xs="auto" className="d-flex align-items-center">
                    <button className="btn btn-primary" type="submit">
                        <i className="fas fa-search" aria-hidden="true"></i>
                    </button>
                </Col>
            </Row>
        </Modal.Header>
        <Modal.Body>
            <Row>
                {records && records.length > 0 ? (
                    records.map((item: any, index: number) => {
                        return (
                            <Col xs={12} sm={6} md={4} key={index} className="mb-3">
                                <div
                                    className="card bg-white shadow-sm clickable h-100"
                                    onClick={() => {
                                        history.push(Routes.PlaceDetails.clean + item.id)
                                        //props.toggle();
                                    }}
                                    style={{
                                        transition: "transform 0.2s ease-in-out",
                                        cursor: "pointer"
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "scale(1.02)"
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "scale(1)"
                                    }}
                                >
                                    <div className="position-relative">
                                        <img
                                            src={`${Settings.BasePathForAPI}file/getThumbnail?filename=${item.image} `}
                                            loading="lazy"
                                            alt={item.placeName}
                                            className="card-img-top"
                                            style={{
                                                height: "200px",
                                                objectFit: "cover",
                                                width: "100%"
                                            }}
                                        />
                                        <div
                                            className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end"
                                            style={{
                                                background: "linear-gradient(transparent 50%, rgba(0,0,0,0.7) 100%)"
                                            }}
                                        >
                                            <div className="text-white p-2 w-100">
                                                <div className="fw-bold text-truncate">{item.name}</div>
                                                <small className="d-block text-truncate opacity-75">
                                                    {item.note}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer bg-white border-0 p-2">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <small className="text-muted fw-medium">
                                                {`${item.assignedToObj?.firstName ?? ""} ${item.assignedToObj?.lastName ?? ""}`}
                                            </small>

                                            <small className="text-muted">
                                                {moment(item.created).fromNow()}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        )
                    })
                ) : (
                    <Col xs={12} className="text-center py-5">
                        <div className="text-muted">
                            <i className="fa fa-history fa-3x mb-3"></i>
                            <h5>{t("Filter the results")}</h5>
                        </div>
                    </Col>
                )}
            </Row>
        </Modal.Body>

    </Modal>
    );
}

export default Search;